"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const React = tslib_1.__importStar(require("react"));
const Alert_1 = tslib_1.__importDefault(require("@mui/material/Alert"));
const Collapse_1 = tslib_1.__importDefault(require("@mui/material/Collapse"));
const useBoolean_1 = tslib_1.__importDefault(require("@eduzz/houston-hooks/useBoolean"));
const Button_1 = tslib_1.__importDefault(require("../Button"));
const useChildrenProps_1 = require("../hooks/useChildrenProps");
const nestedComponent_1 = tslib_1.__importDefault(require("../utils/nestedComponent"));
const Action_1 = tslib_1.__importDefault(require("./Action"));
const styles_1 = tslib_1.__importDefault(require("./styles"));
const Title_1 = tslib_1.__importDefault(require("./Title"));
let alertActionIncrementer = 0;
const Alert = props => {
    const { id, className, children, type = 'success', icon, onClose, closable, multiline } = props;
    const alertProps = { id, className, severity: type, icon, onClose };
    const classes = (0, styles_1.default)();
    const [hide, , , setHide] = (0, useBoolean_1.default)(false);
    const actions = (0, useChildrenProps_1.useChildrenProps)(children, Action_1.default).map(props => (Object.assign(Object.assign({}, props), { id: `action-${alertActionIncrementer++}` })));
    const buttonActions = React.useMemo(() => actions === null || actions === void 0 ? void 0 : actions.map((act, index) => {
        const buttonProps = Object.assign({}, act);
        delete buttonProps.label;
        return ((0, react_1.createElement)(Button_1.default, Object.assign({}, buttonProps, { key: `alert-action-${index}` }), act.label));
    }), [actions]);
    const renderActions = React.useMemo(() => {
        if (multiline)
            return false;
        if (!!actions.length)
            return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.controlButtons }, { children: buttonActions }));
        return null;
    }, [multiline, actions, classes, buttonActions]);
    return ((0, jsx_runtime_1.jsx)(Collapse_1.default, Object.assign({ in: !hide, timeout: 500 }, { children: (0, jsx_runtime_1.jsxs)(Alert_1.default, Object.assign({}, alertProps, { onClose: closable ? setHide : onClose, action: renderActions }, { children: [children, multiline && buttonActions.length > 0 && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.controlButtonsMultiline }, { children: buttonActions })))] })) })));
};
exports.default = (0, nestedComponent_1.default)(React.memo(Alert), { Title: Title_1.default, Action: Action_1.default });
